import { CSSObject } from "@emotion/react";
import { mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const loadingWrapperCss: CSSObject = {
  height: "70vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const loadingSpinnerWrapperCss: CSSObject = {
  height: "96px",
  width: "96px",
};

export const bodyWrapperCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
  padding: "24px 16px",
  gap: "24px",
  overflowX: "auto",

  "> :last-child": {
    alignSelf: "stretch",
  },
};

export const galleryPreviewWrapperCss: CSSObject = {
  display: "flex",
  width: "max-content",
  height: "100%",
  maxHeight: "800px",
  gap: "16px",
  overflow: "visible",
  "> *": {
    flexShrink: 0,
  },
  "> :last-child": {
    maxWidth: 967,
    flexGrow: 1,
  },
};

export const paragraphCss: CSSObject = {
  margin: "0",
};

export const instructionsCss: CSSObject = {
  whiteSpace: "nowrap",
};

export const hideOnMobileCss: CSSObject = {
  [breakpoint.upTo("xs")]: {
    display: "none",
  },
};

export const hideOnTabletAndUpCss: CSSObject = {
  [breakpoint.downTo("xs")]: {
    display: "none",
  },
};
